'use strict';

require('slick-carousel');

module.exports = function($) {
	var newCarousel 	= jQuery('[data-carousel-type]');

	return {
		init: init
	};

	function init() {
		makeCarousel();
	}

	// set up carousels
	function makeCarousel() {
		$.each(newCarousel, function() {

			var sliderType 	= $(this).data('carousel-type');
			var slides 			= $('.carousel__slides', this);

			// defaults
			var slideOptions = {
				nextArrow: $('.carousel__controls .control--next', this),
				prevArrow: $('.carousel__controls .control--prev', this),
				speed: 650,
				infinite: true,
				cssEase: 'ease-in-out',
				responsive: [
					{
						breakpoint: 767,
						settings: {
							dots: true,
							swipeToSlide: true
						}
					}
				]
			};


			// small carousel
			if (sliderType === 'sm') {
				slideOptions = {
					autoPlay: true,
					centerMode: true,
					centerPadding: '120px',
					slidesToShow: 4,
					swipeToSlide: true,
					nextArrow: $('.carousel__controls .control--next', this),
					prevArrow: $('.carousel__controls .control--prev', this),
					speed: 650,
					infinite: true,
					cssEase: 'ease-in-out',
					edgeFriction: 0.75,
					dots: true,
					responsive: [
						{
							breakpoint: 1600,
							settings: {
								slidesToShow: 3,
							}
						},
						{
							breakpoint: 1220,
							settings: {
								slidesToShow: 2,
								centerPadding: '60px',
							}
						},
						{
							breakpoint: 767,
							settings: {
								dots: false,
								swipeToSlide: true,
								slidesToShow: 1,
							}
						},
						{
							breakpoint: 413,
							settings: {
								dots: true,
								swipeToSlide: true,
								slidesToShow: 1,
								centerMode: false
							}
						}
					]
				};

			}

			if (sliderType === 'videos') {
				slideOptions = {
					autoPlay: false,
					centerMode: true,
					centerPadding: '25%',
					slidesToShow: 1,
					swipeToSlide: true,
					nextArrow: $('.carousel__controls .control--next', this),
					prevArrow: $('.carousel__controls .control--prev', this),
					speed: 650,
					infinite: true,
					cssEase: 'ease-in-out',
					edgeFriction: 0.75,
					responsive: [
						{
							breakpoint: 990,
							settings: {
								dots: true,
								swipeToSlide: true,
								slidesToShow: 1,
								centerMode: false
							}
						}
					]
				};

			}





			// init slick slider with options
			slides.slick(slideOptions);

		});
	}

};
